import className from "classnames/bind";

import styles from "./IconButton.module.scss";
const cx = className.bind(styles);

interface IconButtonProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  size?: "small" | "medium" | "large";
  ariaLabel?: string;
  playVideoLabel?: string;
  className?: string;
  disabled?: boolean;
  tabindex?: number;
  onClick?: () => void;
  tag?: React.ElementType;
}

export default function IconButton({
  icon,
  size = "large",
  ariaLabel,
  className = "",
  onClick,
  disabled = false,
  tabindex = 0,
  tag,
}: IconButtonProps) {
  const Element = icon;
  const Tag = tag ? tag : "button";
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.();
  };
  return (
    <Tag
      className={cx(["icon-button", size, className])}
      disabled={disabled}
      tabIndex={disabled ? -1 : tabindex}
      onClick={handleClick}
      aria-label={ariaLabel || ""}
      role="button"
    >
      <Element className={cx(["icon"])} />
    </Tag>
  );
}
